import Vue from "vue";
import VueRouter from "vue-router";
import LayoutDefault from "../layouts/default";
import LayoutExtended from "../layouts/extended";
import Login from "@/views/login";
import Cadastro from "@/views/cadastro";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: LayoutDefault,
    children: [
      {
        name: "Home",
        path: "",
        component: () => import("../views/pessoa/home/details"),
      },
      {
        name: "DadosPessoais",
        path: "details",
        component: () => import("../views/pessoa/dados-pessoais/details"),
      },
      {
        name: "DadosFisicos",
        path: "physical-details",
        component: () => import("../views/pessoa/dados-fisicos/details"),
      },
      {
        name: "DadosSanguineos",
        path: "blood-details",
        component: () => import("../views/pessoa/dados-sanguineos/details"),
      },
      {
        name: "Medicamentos",
        path: "medicaments",
        component: () => import("../views/pessoa/medicamentos/details"),
      },
      {
        name: "Doencas",
        path: "diseases",
        component: () => import("../views/pessoa/doencas/details"),
      },
      {
        name: "CarteiraVacinacao",
        path: "vaccination",
        component: () => import("../views/pessoa/carteira-vacinacao/details"),
      },
      {
        name: "ProntuarioMedico",
        path: "medical-record",
        component: () => import("../views/pessoa/prontuario-medico/details"),
      },
      {
        name: "OutrasInformacoes",
        path: "informations",
        component: () => import("../views/pessoa/outras-informacoes/details"),
      },
      {
        name: "DadosPrivados",
        path: "privacy",
        component: () => import("../views/pessoa/dados-privados/details"),
      },
      {
        name: "PessoaQRCodes",
        path: "qrcodes",
        component: () => import("../views/qrcodes"),
      },
      {
        name: "PessoaLifeCard",
        path: "life-card",
        component: () => import("../views/life-card"),
      },
    ],
  },
  {
    path: "/pet",
    component: LayoutDefault,
    children: [
      {
        name: "PetHome",
        path: "",
        component: () => import("../views/pet/home/details"),
      },
      {
        name: "PetDados",
        path: "details",
        component: () => import("../views/pet/dados-pet/details"),
      },
      {
        name: "PetDadosFisicos",
        path: "physical-details",
        component: () => import("../views/pet/dados-fisicos/details"),
      },
      {
        name: "PetDadosAlimentacao",
        path: "fooding",
        component: () => import("../views/pet/dados-alimentacao/details"),
      },
      {
        name: "PetMedicamentos",
        path: "medicaments",
        component: () => import("../views/pet/medicamentos/details"),
      },
      {
        name: "PetDoencas",
        path: "diseases",
        component: () => import("../views/pet/doencas/details"),
      },
      {
        name: "PetCarteiraVacinacao",
        path: "vaccination",
        component: () => import("../views/pet/carteira-vacinacao/details"),
      },
      {
        name: "PetProntuarioMedico",
        path: "medical-record",
        component: () => import("../views/pet/prontuario-medico/details"),
      },
      {
        name: "PetOutrasInformacoes",
        path: "informations",
        component: () => import("../views/pet/outras-informacoes/details"),
      },
      {
        name: "PetDadosPrivados",
        path: "privacy",
        component: () => import("../views/pet/dados-privados/details"),
      },
      {
        name: "PetQRCodes",
        path: "qrcodes",
        component: () => import("../views/qrcodes"),
      },
      {
        name: "PetLifeCard",
        path: "life-card",
        component: () => import("../views/life-card"),
      },
    ],
  },
  {
    path: "/tag",
    component: LayoutDefault,
    children: [
      {
        name: "TagHome",
        path: "",
        component: () => import("../views/tag/home/details"),
      },
      {
        name: "TagFuncionario",
        path: "employee",
        component: () => import("../views/tag/funcionario/details"),
      },
      {
        name: "TagDadosPessoais",
        path: "details",
        component: () => import("../views/tag/dados-pessoais/details"),
      },
      {
        name: "TagDadosFisicos",
        path: "physical-details",
        component: () => import("../views/tag/dados-fisicos/details"),
      },
      {
        name: "TagDadosSanguineos",
        path: "blood-details",
        component: () => import("../views/tag/dados-sanguineos/details"),
      },
      {
        name: "TagMedicamentos",
        path: "medicaments",
        component: () => import("../views/tag/medicamentos/details"),
      },
      {
        name: "TagDoencas",
        path: "diseases",
        component: () => import("../views/tag/doencas/details"),
      },
      {
        name: "TagCarteiraVacinacao",
        path: "vaccination",
        component: () => import("../views/tag/carteira-vacinacao/details"),
      },
      {
        name: "TagProntuarioMedico",
        path: "medical-record",
        component: () => import("../views/tag/prontuario-medico/details"),
      },
      {
        name: "TagAnexos",
        path: "attachments",
        component: () => import("../views/tag/anexos/details"),
      },
      {
        name: "TagOutrasInformacoes",
        path: "informations",
        component: () => import("../views/tag/outras-informacoes/details"),
      },
      {
        name: "TagDadosPrivados",
        path: "privacy",
        component: () => import("../views/tag/dados-privados/details"),
      },
      {
        name: "TagQRCodes",
        path: "qrcodes",
        component: () => import("../views/qrcodes"),
      },
      {
        name: "TagLifeCard",
        path: "life-card",
        component: () => import("../views/life-card"),
      },
    ],
  },
  {
    path: "/login",
    component: LayoutExtended,
    children: [{ path: "", component: Login }],
  },
  {
    path: "/sign-up",
    component: LayoutExtended,
    children: [{ path: "", component: Cadastro }],
  },
  {
    path: "/app/id/:id",
    component: LayoutExtended,
    children: [
      {
        path: "",
        component: () => import("../views/bem-vindo"),
      },
    ],
  },
  {
    path: "/app/pet/:id",
    component: LayoutExtended,
    children: [
      {
        path: "",
        component: () => import("../views/bem-vindo"),
      },
    ],
  },
  {
    path: "/app/tag/:id",
    component: LayoutExtended,
    children: [
      {
        path: "",
        component: () => import("../views/bem-vindo"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
//   component: () =>
//     import(/* webpackChunkName: "about" */ "../views/About.vue"),
// },
